import axiosInstance from "../../../services/axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/pursuit";

export async function createPursuit(variables) {
  const response = await instance.post(`/create`, variables, {
    timeout: 200000,
  });
  return response.data;
}

export async function getPursuit(pursuit_id) {
  if (!pursuit_id) return null;
  const response = await instance.get(`/get/${pursuit_id}`);
  return response.data;
}

export async function getUserPursuits() {
  const response = await instance.get(`/get`);
  return response.data;
}

export async function updatePursuitKanban(data) {
  const updates = data.map((pursuit) => ({
    id: pursuit.id,
    search_type: pursuit.search_type,
    proposal_id: pursuit.proposal_id,
    index: pursuit.kanban_row_index,
    status: pursuit.status,
  }));
  const response = await instance.post(`/update-kanban`, updates);
  return response.data;
}

export async function updatePursuit(variables) {
  const response = await instance.patch("/update", variables);
  return response.data;
}

export async function deletePursuit(pursuitId) {
  const response = await instance.delete(`/delete/${pursuitId}`);
  return response.data;
}

export async function populateDeepInsights(pursuit_id) {
  const response = await instance.get(`/deep-insights/${pursuit_id}`, {
    timeout: 60000,
  });
  return response.data;
}
